import { render, staticRenderFns } from "./MessageStorageMedia.vue?vue&type=template&id=95dc10aa&scoped=true"
import script from "./MessageStorageMedia.vue?vue&type=script&lang=js"
export * from "./MessageStorageMedia.vue?vue&type=script&lang=js"
import style0 from "./MessageStorageMedia.vue?vue&type=style&index=0&id=95dc10aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dc10aa",
  null
  
)

export default component.exports